// Convert text to binary
export const convertTextToBinary = (text) => {
  try {
    if (!text) return { convertedData: '', isError: false };

    const binary = text
      .split('')
      .map((char) => char.charCodeAt(0).toString(2).padStart(8, '0'))
      .join(' ');

    return { convertedData: binary, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid input', isError: true };
  }
};

// Convert binary to text with proper validation
export const convertBinaryToText = (binaryStr) => {
  if (!binaryStr) return { convertedData: '', isError: false };

  const binaryArray = binaryStr.trim().split(/\s+/);

  for (let bin of binaryArray) {
    // Check if bin contains only 0s and 1s and is at most 8 bits
    if (!/^[01]{1,8}$/.test(bin)) {
      return { convertedData: 'Error: Invalid binary input', isError: true };
    }
  }

  try {
    const text = binaryArray
      .map((bin) => String.fromCharCode(parseInt(bin, 2)))
      .join('');

    return { convertedData: text, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid binary input', isError: true };
  }
};

// CurrencyConvertor.js
const exchangeRates = {
  USD: { USD: 1, EUR: 0.92, INR: 83, GBP: 0.80, JPY: 144 },
  EUR: { USD: 1.09, EUR: 1, INR: 90, GBP: 0.87, JPY: 157 },
  INR: { USD: 0.012, EUR: 0.011, INR: 1, GBP: 0.0097, JPY: 1.74 },
  GBP: { USD: 1.25, EUR: 1.15, INR: 104, GBP: 1, JPY: 180 },
  JPY: { USD: 0.0069, EUR: 0.0064, INR: 0.57, GBP: 0.0056, JPY: 1 },
};

export const convertCurrency = (amount, from, to) => {
  try {
    if (!amount || isNaN(amount)) return { convertedData: '', isError: true };
    if (!exchangeRates[from] || !exchangeRates[to]) return { convertedData: '', isError: true };

    const converted = parseFloat(amount) * exchangeRates[from][to];
    return { convertedData: converted.toFixed(2), isError: false };
  } catch (err) {
    return { convertedData: '', isError: true };
  }
};

